import DomComponent from 'App/lib/domComponent';
import DropdownComponent from '../dropdown/dropdown';
import {
    each
} from 'App/lib/util';
import InputComponent from './input';
import selectTemplate from './select.template.pug';

/**
 * A custom drop down implementation.
 */
export default class SelectComponent extends DomComponent {
    static selector = '[data-js-select]';
    static template = selectTemplate;
    defaultOption;
    lastActiveOption;
    showOptionLabels;
    trueValue;
    mirrorValueToOriginal;

    _value;

    set value(v) {
        let i, option;
        const event = new CustomEvent('value:change', {
            detail: {
                value: v,
                name: this.id
            },
        });

        this.el.dispatchEvent(event);

        if (this.input) {
            if (this.showOptionLabels && this.trueValue) {
                for (i = 0; i < this.options.length; i++) {
                    option = this.options[i];
                    if (option.getAttribute('data-value') === v) {
                        this.input.setValue(option.getAttribute('data-label'));
                        this.trueValue.value = v;
                        break;
                    }
                }
            } else {
                this.input.setValue(v);
            }
        }

        this._value = v;
    }

    get value() {
        return this.input.value;
    }

    get id() {
        return this.el.dataset.select ? this.el.dataset.select : (this.input ? this.input.el.getAttribute('name') : '');
    }

    setValue(val) {
        if (val === null) {
            this.value = null;
            this.input.setValue(null);
            this.clean();
            if (this.lastActiveOption) {
                this.lastActiveOption.classList.remove('active');
            }
        } else {
            each(this.options, (option) => {
                if (option.dataset.value === val) {
                    this.value = val;
                    this.mirrorValueToOriginal.value = val;
                }
            });
        }
    }


    constructor(el) {

        super(el, {
            cache: true
        });

        // Show the labels for the options rather than the values once selecting an option?
        if (el.showOptionLabels) {
            this.showOptionLabels = true;
        }

        // When the value changes in our custom select, set the value on the original
        // field as well. Note that this is an HTML element and not a bool.
        if (el.mirrorValueToOriginal) {
            this.mirrorValueToOriginal = el.mirrorValueToOriginal;
        }

        const input = this.el.querySelector('[data-readonly-input]');
        this.trueValue = this.el.querySelector('[data-true-value]');
        this.options = this.el.querySelectorAll('[data-option]');
        this.deselectOption = this.el.querySelector('[data-deselect]');

        this.dropdown = this.dropdown || new DropdownComponent(this.el.querySelector('[data-js-dropdown]'), this.el);

        if(this.deselectOption != null){
            this.deselectOption.classList.add('hidden');
        }

        if (input) {
            this.input = this.input || new InputComponent(input);
        }

        this.dropdown.el.addEventListener('dropdown:open', () => {
            this.input.dirty();
            this.input.focus();
        });

        this.dropdown.el.addEventListener('dropdown:close', () => {
            this.input.blur();

            if (!this.input.value) {
                this.input.clean();
            }
        });

        this.errorMessage = this.createErrorMessage();

        each(this.options, (option) => {
            option.addEventListener('click', this.changeHandler.bind(this, option));
        });

        setTimeout(() => {
            this.loaded();
        })
    }

    createErrorMessage() {
        const div = document.createElement('div');
        div.classList.add('form__error');
        return div;
    }

    setError(valid, message) {
        if (valid) {
            this.el.classList.remove('error');
            setTimeout(() => {
                this.errorMessage.remove();
            });
        } else {
            this.errorMessage.innerText = message;
            this.el.appendChild(this.errorMessage);
            this.el.classList.add('error');
        }
    }

    validate() {
        let valid = true;
        let message = "";

        if (this.el.dataset.required) {
            if (this.value === null || this.value === '') {
                valid = false;
                message = 'This field is required.';
            }
        }

        this.setError(valid, message);

        return valid;
    }


    changeHandler(option) {
        this.setValue(option.dataset.value);
        if (this.lastActiveOption) {
            this.lastActiveOption.classList.remove('active');
        }
        if(this.deselectOption != null){
            this.deselectOption.classList.remove('hidden');
        }

        this.lastActiveOption = option;
        option.classList.add('active');
        // this.value = option.dataset.value;
        // this.label = option.innerText;

        this.dropdown.close();
    }

    getOption(value) {
        let option = this.options[0];
        each(this.options, (_option) => {
            if (_option.dataset.value === value) {
                option = _option;
            }
        });

        return option;
    }

    clean() {
        this.input.clean();
    }
}
